/** Copyright (c) 2021 T. Rowe Price. All rights reserved. */

import { RECEIVED_TOTAL_PERFORMANCE } from './PerformanceActions';

export const totalPerformance = (state = {}, action) => {
  if (action.type !== RECEIVED_TOTAL_PERFORMANCE) {
    return state;
  }
  return action.totalPerformance;
};
